import { TranslateService } from '@ngx-translate/core';

// Field labels used as keys of ChartNode.data. Kept in sync with the labels of the original
// chart (org-chart/components/org-chart-display/org-charts-util.ts) so both charts show the same
// details, without coupling this chart to the BALKAN-based code.
export class OrgChartFields {

  constructor(private translate: TranslateService) {
  }

  readonly POSITION = {
    positionName: 'Position Name',
    jobTitle: 'Functional Job Title',
    marketPositionTitle: 'Market Position Title',
    marketPosition: 'Market Position',
    marketView: 'Market View',
    unionCode: 'Union Code',
    shiftCode: 'Shift Code',
    numberSlots: 'Number Of Slots',
    enforceSlotLimit: 'Enforce Slot Limit',
    department: 'Department',
    division: 'Division',
    empCategory: 'Employee Category',
    empGroup: 'Employment Group',
    empType: 'Employment Type',
    jobBand: 'Job Band',
    jobFamily: 'Job Family',
    jobGroup: 'Job Group',
    jobType: 'Job Type',
    projectTeam: 'Project Team',
    region: 'Region',
    country: 'Country',
    workLocation: 'Work Location',
    subDivision: 'Sub Division',
    workRotation: this.translate.instant('WorkRotation'),
    workRotationStart: this.translate.instant('WorkRotationStartDate'),
    isVacant: 'Position Occupancy',
    startDate: 'Start Date',
    endDate: 'End Date',
    status: 'Status',
  };

  readonly EMPLOYEE = {
    name: 'Name',
    positions: 'Positions',
    firstName: 'First Name',
    lastName: 'Last Name',
    title: 'Title',
    preferred: 'Preferred',
    maidenName: 'Maiden Name',
    middleName: 'Middle Name',
    gender: 'Gender',
    cultureAffil: 'Cultural Affiliation',
    religiousAffil: 'Religious Affiliation',
    linkedin: 'Linkedin',
    twitter: 'Twitter',
    facebook: 'Facebook',
    status: 'Status',
    birthday: 'Birthday',
    maritalStatus: 'Marital Status',
    subStatus: 'Substatus',
    language: 'Preferred Language',
    streetAddress: 'Street Address',
    city: 'City',
    province: 'Province',
    zip: 'Zip',
    country: 'Country',
    email: 'Email',
    workPhone: 'Work Phone',
    homePhone: 'Home Phone',
    cellPhone: 'Cellphone',
    culture: 'Culture',
  };

  readonly ORGANIZATION = {
    name: 'Name',
    startDate: 'Start Date',
    endDate: 'End Date',
    organizationType: 'Organization Type',
  };

  // Position fields offered as filters, matching the original chart's filterBy.
  readonly POSITION_FILTERS: string[] = [
    this.POSITION.isVacant,
    this.POSITION.department,
    this.POSITION.division,
    this.POSITION.workLocation,
    this.POSITION.region,
    this.POSITION.country,
    this.POSITION.projectTeam,
    this.POSITION.empType,
    this.POSITION.empCategory,
  ];
}
